const LONG = new Intl.DateTimeFormat('en-GB', {
  weekday: 'short',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

const SHORT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

const TIME = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
})

/** A date-only column, rendered without inventing a timezone for it. */
function dateOnly(iso: string): Date {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number)
  return new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1, d ?? 1))
}

export function longDate(iso: string | null): string {
  return iso === null ? '—' : LONG.format(dateOnly(iso))
}

export function shortDate(iso: string | null): string {
  return iso === null ? '—' : SHORT.format(dateOnly(iso))
}

export function timeOfDay(iso: string | null): string {
  return iso === null ? '—' : TIME.format(new Date(iso))
}

/** Today in Europe/London as a date-only string, matching the back end. */
export function today(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/London',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date())
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`
}

/** "1 April", from the two smallint columns on organisations. */
export function leaveYearStart(month: number, day: number): string {
  const names = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ]
  return `${day} ${names[month - 1] ?? '?'}`
}
